import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import {
    closeInfoModal,
    openInfoModal,
    setInfoModalData,
    setInfoModalDataState,
} from '../../actions/app/infoModal.actions'
import infoModalSelector from '../../selectors/infoModalSelector'
import { InfoModalTypes } from '../../../entities/InfoModalType'

const infoModalMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)
    const { dispatch, getState } = store

    if (isActionOf(setInfoModalData, action)) {
        dispatch(setInfoModalDataState(action.payload))
    }

    if (isActionOf(openInfoModal, action)) {
        dispatch(setInfoModalData({
            ...action.payload,
            activeModalType: action.payload?.activeModalType ?? InfoModalTypes.INFO,
        }))
    }

    if (isActionOf(closeInfoModal, action)) {
        const infoModalData = infoModalSelector(getState())
        const onCloseCallback = infoModalData.onClose

        if (onCloseCallback) {
            dispatch(onCloseCallback)
        }

        dispatch(setInfoModalData({
            activeModalType: null,
        }))
    }
}

export default infoModalMiddleware
